import { render, staticRenderFns } from "./CompliancePopover.vue?vue&type=template&id=05db08fe&"
import script from "./CompliancePopover.vue?vue&type=script&lang=js&"
export * from "./CompliancePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports